// Route path constants
export const ROUTE_PATHS = {
  DEFAULT_SEARCH_PRODUCT_PAGE: 'search',
  CATEGORY_PRODUCTS_PAGE: 'products',
  COLLECTION_PRODUCTS_PAGE: 'collection'
}

// Filter key constants
export const FILTER_KEYS = {
  CATEGORIES: 'categories',
  BRANDS: 'brands',
  BULLETIN_PICKS: 'bulletin_picks',
  BUY_ON_BULLETIN: 'buy_on_bulletin',
  BRAND_VALUES: 'brand_values',
  SHIP_BY: 'max_lead_time',
  LOCATION: 'location',
  COUNTRY: 'country',
  PRICE_FROM: 'price_from',
  PRICE_TO: 'price_to',
  MOV: 'mov',
  KEYWORD: 'keyword',
  SECTIONS: 'sections',
  SPECIAL_SERVICES: 'special_services',
  DEALS_PROMOTIONS: 'deals_promotions'
}

export const QUICK_FILTER_KEYS = {
  NEW_ARRIVALS: 'new_arrivals',
  DEALS_AND_PROMOS: 'deals_and_promos',
  BULLETIN_PICKS: 'bulletin_picks',
  ACTIVE_TRADE_SHOW_ID: 'active_trade_show_id'
}

// Algolia index constants
export const ALGOLIA_INDEX_KEYS = {
  CREATED_AT_ASC: 'created_at_asc',
  TOTAL_ORDERS_DESC: 'total_orders_desc',
  PRICE_ASC: 'price_asc',
  PRICE_DESC: 'price_desc'
}
